import * as React from "react";
import { RxFormField, RxFormFields } from "components/rx-form";
import Typography from '@material-ui/core/Typography';
import { SpecField } from "common/api/Forms";
import FileUpload from "components/controls/form-inputs/FileUpload";
import Text from "components/controls/form-inputs/Text";
import Selection from "components/controls/form-inputs/Selection";

const allowedExtensions: string[] = ['pdf', 'png', 'jpg', 'jpeg'];

const getDokladTotoznosti = (fs: SpecField, field: RxFormField, uploadFileUrl: string) => {

    return <div>
        <Typography variant="h6">{fs.label}</Typography>
        <Typography variant="body2">{'Vložte sken vašeho občanského průkazu nebo jiného dokladu vaší totožnosti. Vložením dokladu souhlasíte se zpracováním údajů v ČSTS dle nařízení GDPR ('}<a href="../../../../../../cs/Files/GetFile/2518" target="_blank">{'směrnice OB06'}</a>{'). Po provedení prezence a ověření totožnosti bude zaslaná kopie průkazu totožnosti skartována/vymazána a dále již nebude archivována.'}</Typography>
        <FileUpload {...field} maxFiles={fs.file.max} uploadFileUrl={uploadFileUrl} allowedExtensions={allowedExtensions} />
    </div>;
}

const getTypHlasovani = (fs: SpecField, field: RxFormField) => {
    return <div>
        <Typography variant="h6">{fs.label}</Typography>
        <Typography variant="body2">{fs.description}</Typography>
        <Selection variant={fs.selection.type} {...fs.selection} {...field} />
    </div>;
}

const getPlneMoci = (fs: SpecField, field: RxFormField, uploadFileUrl: string, fields: RxFormFields) => {

    const description = fields['typ_hlasovani'].value === "2" ? 'Vložte PDF nebo JPG skenu podepsané plné moci.' : fs.description;
    const label = fields['typ_hlasovani'].value === "2" ? 'Plná moc' : fs.label;

    return <div>
        <Typography variant="h6">{label}</Typography>
        <Typography variant="body2">{description}</Typography>
        <FileUpload {...field} maxFiles={fs.file.max} uploadFileUrl={uploadFileUrl} allowedExtensions={allowedExtensions} />
    </div>;
}

const getVolbaDelegatu = (fs: SpecField, field: RxFormField) => {
    return <div>
        <Typography variant="h6">{fs.label}</Typography>
        <Typography variant="body2">{fs.description}</Typography>
        <Selection variant={fs.selection.type} {...fs.selection} {...field} />
    </div>;
}

const getPocetHlasu = (fs: SpecField, field: RxFormField) => {
    return <div>
        <Typography variant="h6">{fs.label}</Typography>
        <Typography variant="body2">{fs.description}</Typography>
        <Text {...field} />
    </div>;
}

const getHlasovaniVK = (fs: SpecField, field: RxFormField) => {
    const descItems = fs.description.split('|');
    return <div>
        <Typography variant="h6">{fs.label}</Typography>
        <Typography variant="body1">{descItems[0]}<a href={`../../../../../../cs/Files/GetFile/${descItems[2]}`} target="_blank">{descItems[1]}</a></Typography>
        <Typography variant="subheading">{'Hlasuji:'}</Typography>
        <Selection variant={fs.selection.type} {...fs.selection} {...field} singleSelect />
    </div>;
}


const buildFormControl = (fs: SpecField, field: RxFormField, uploadFileUrl: string, fields: RxFormFields) => {

    switch (fs.name) {
        case 'doklad_totoznosti': return getDokladTotoznosti(fs, field, uploadFileUrl);
        case 'typ_hlasovani': return getTypHlasovani(fs, field);
        case 'plne_moci': if (field.disabled === false) {
            return getPlneMoci(fs, field, uploadFileUrl, fields);
        }
            break;
        case 'volba_delegatu': return getVolbaDelegatu(fs, field);
        case 'pocet_hlasu': if (field.disabled === false) {
            return getPocetHlasu(fs, field);
        }
            break;
    }

    for (let i = 1; i <= 22; i++) {
        if (fs.name === `hlasovani_${i}`) {
            return getHlasovaniVK(fs, field);
        }
    }

    return null;
}

export default buildFormControl;